import { Box, useMediaQuery, useTheme } from '@mui/material';
import { ChatClient } from '../../components/chat-system/ChatClient';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { useChatClient } from '../../components/chat-system/useChatClient';

const getVisualHeight = () => {
  if (typeof window === 'undefined') return 0;
  if (window.visualViewport) return window.visualViewport.height;
  return window.innerHeight;
};

const Chat = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchParams] = useSearchParams();
  const { conversations, setSelectedConversation } = useChatClient();
  const conversationId = searchParams.get('conversation');
  const [viewportHeight, setViewportHeight] = useState(getVisualHeight());

  // Track viewport height — visualViewport.resize fires when iOS keyboard appears
  const updateViewportHeight = useCallback(() => {
    setViewportHeight(getVisualHeight());
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', updateViewportHeight);
      vv.addEventListener('scroll', updateViewportHeight);
    }
    window.addEventListener('resize', updateViewportHeight);
    const orientationHandler = () => setTimeout(updateViewportHeight, 100);
    window.addEventListener('orientationchange', orientationHandler);

    return () => {
      if (vv) {
        vv.removeEventListener('resize', updateViewportHeight);
        vv.removeEventListener('scroll', updateViewportHeight);
      }
      window.removeEventListener('resize', updateViewportHeight);
      window.removeEventListener('orientationchange', orientationHandler);
    };
  }, [updateViewportHeight]);

  // Auto-select conversation from URL parameter
  useEffect(() => {
    if (conversationId && conversations.length > 0) {
      const conversation = conversations.find(c => c.id === parseInt(conversationId));
      if (conversation) {
        setSelectedConversation(conversation);
      }
    }
  }, [conversationId, conversations, setSelectedConversation]);

  // Mobile: anchor to visualViewport so iOS keyboard shrinks the chat instead of hiding the input
  if (isMobile) {
    const topbarHeight = 44;
    const mobileMenuHeight = 35;
    const chatHeight = Math.max(0, viewportHeight - topbarHeight - mobileMenuHeight);

    return (
      <Box
        sx={{
          position: 'fixed',
          top: topbarHeight,
          left: 0,
          right: 0,
          height: chatHeight,
          overflow: 'hidden',
          zIndex: 10,
        }}
      >
        <ChatClient />
      </Box>
    );
  }

  return (
    <Box className="md:pt-[43px] h-full w-full flex flex-col overflow-hidden">
      <ChatClient />
    </Box>
  );
};

export default Chat;
